export default __webpack_public_path__ + "static/media/develop_side.c22d9d05.png";